module.exports = __webpack_public_path__ + "static/media/Mouth_5.52e96584.jpg";